"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateLeakPoint = void 0;
const types_1 = require("../../types");
const generateLeakPoint = (value, timestamp, leakDetected, labelProvider) => {
    if (leakDetected) {
        return {
            value,
            timestamp,
            leakDetected,
            threshold: types_1.LeakThreshold.LeakDetected,
            color: types_1.LeakColor.Red,
            label: labelProvider(types_1.LeakThreshold.LeakDetected),
        };
    }
    if (value !== null) {
        if (value <= 50) {
            return {
                value,
                timestamp,
                leakDetected,
                threshold: types_1.LeakThreshold.NoLeak,
                color: types_1.LeakColor.Green,
                label: labelProvider(types_1.LeakThreshold.NoLeak),
            };
        }
        else if (value > 50 && value <= 60) {
            return {
                value,
                timestamp,
                leakDetected,
                threshold: types_1.LeakThreshold.SlightlyHumid,
                color: types_1.LeakColor.Yellow,
                label: labelProvider(types_1.LeakThreshold.SlightlyHumid),
            };
        }
        else if (value > 60 && value <= 70) {
            return {
                value,
                timestamp,
                leakDetected,
                threshold: types_1.LeakThreshold.HighHumidity,
                color: types_1.LeakColor.Red,
                label: labelProvider(types_1.LeakThreshold.HighHumidity),
            };
        }
        else if (value > 70) {
            return {
                value,
                timestamp,
                leakDetected,
                threshold: types_1.LeakThreshold.ExtremelyHumid,
                color: types_1.LeakColor.Red,
                label: labelProvider(types_1.LeakThreshold.ExtremelyHumid),
            };
        }
    }
    return {
        value,
        timestamp,
        leakDetected,
        threshold: types_1.LeakThreshold.NoLeak,
        color: types_1.LeakColor.Green,
        label: labelProvider(types_1.LeakThreshold.NoLeak),
    };
};
exports.generateLeakPoint = generateLeakPoint;
